/* eslint-disable */
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Storage, API } from 'aws-amplify';
import { FormGroup, Label, Input, FormText, Card, CardHeader, CardBody, Row, Col, Button } from 'reactstrap';
import { Progress } from 'reactstrap';
import OpenAI from 'openai';

import Icon from '@mdi/react';
import { mdiFormatListBulletedType, mdiMessageText, mdiNoteOutline, mdiNoteText } from '@mdi/js';
import { getAiCredentials, getPrompts, isCustomPrompt, isOpenAi, reWriteContent } from './AiFunctions';
import { CommonPageSpinner } from '../Components/CommonSpinner';
// import LoadingAlert from '../App/CommonComponents/LoadingAlert';

var openai_key = "", openai_model = "", openai = "";

class AiPromptPopUp extends Component {
    constructor(props) {
        //console.log(props);

        const globalvariables = global.$variables; // Accessing Global variables

        var ai_prompt = getPrompts(props.type);
        var [aikey, aimodel] = getAiCredentials();
        
        openai_key = aikey
        openai_model = aimodel
        
        super(props);
        this.state = {
            code: globalvariables.code,
            poolid: globalvariables.pid,
            description: props.description,
            modifiedresponse: '',
            prompt_val: '',
            custom_prompt: '',
            openai_prompt: ai_prompt,
            loadingPopup: false  
        }

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleAccept = this.handleAccept.bind(this);

        // if(props.editorState) {
        //     this.convertHtmltoText();
        // }
    }

    // convertHtmltoText = () => {
    //     var text_description = this.state.description.replace(/<[^>]+>/g, '');
    //     // this.state.description = text_description;
    //     // this.state.modifiedresponse = text_description

    //     this.setState({
    //         description: text_description,
    //         modifiedresponse: text_description
    //     })
    // }

    convertHtmltoText = () => {
        var html = this.state.description

        // Create a new div element
        var tempDivElement = document.createElement("div");

        // Set the HTML content with the given value
        tempDivElement.innerHTML = html;

        // Retrieve the text property of the element 
        var text_description = tempDivElement.textContent || tempDivElement.innerText || "";

        this.setState({
            description: text_description,
            modifiedresponse: text_description
        })
    }

    componentDidMount() {
        if(openai_key) {
            openai = new OpenAI({
                apiKey:  openai_key,
                dangerouslyAllowBrowser: true
            });
        }

        //if(this.props.editorState) {
            this.convertHtmltoText();
        //}
    }

    handleInputChange(event) {
        const target = event.target;
        const name = target.name;
        let value = target.value

        //console.log( "Target = " + name + ", Value = " + value);
        this.setState({ [name]: value });
    }

    handleAccept() {
        //console.log('handleAccept');

        var response = this.state.modifiedresponse ? this.state.modifiedresponse : this.state.description
        if(this.props.editorState) {
            this.props.changeBio(response);   
        }
        else {
            this.props.changeBio(this.props.name,response);
        }

        this.props.exit();
    }

    render() {
        return(
            <div>
                {this.renderUI()}
                {/* {this.state.loadingPopup && <LoadingAlert message={"Creating AI-driven content, Please Wait..."} />} */}
            </div>
        )
    }

    renderUI() {
        return(
            <>
            {
                isOpenAi
                ?
                this.getOpenAi()
                : ''
            }
            </>
        )
    }

    getOpenAi() {
        return(
            <div className="shadow-form" >
                <Row>
                    <Col md={10}>
                    <FormGroup className="form-labels">  
                        <Label><Icon path={mdiFormatListBulletedType} size={0.9} className="form-label-icon" />What would you like to do?</Label>
                        <Input type="select" name="prompt_val" id="prompt" className="form-control-sm" value={this.state.prompt_val || ''} onChange={this.handleInputChange}>
                            <option value="">Select</option>
                            {
                                this.state.openai_prompt.map((data) => {
                                    return(
                                        <option value={data}>{data}</option>
                                    )
                                })
                            }
                        </Input>
                    </FormGroup>                               
                    </Col>

                    <Col>
                        <Label><Icon className="form-label-icon"></Icon></Label>
                            <button
                            className="form-control-sm btn attendeesearchbtn send_email"
                            onClick={this.handleInvokeAI}
                            type="button"
                            text="Accept"
                            >Ask AI</button>
                        
                    </Col>
                </Row>

                {
                    isCustomPrompt(this.props.type) ?
                    <Row>
                        <Col>
                            <Label className="card_icon_div"><Icon path={mdiNoteText} size={0.9} className="form-label-icon" />Enter your prompt</Label>
                            <Input type="text" name="custom_prompt" className="form-control-sm" id="custom_prompt" value={this.state.title} onChange={this.handleInputChange} />
                        </Col>    
                    </Row>  : ''                 
                }

                <Row>
                    <Col>
                        <FormGroup className="form-labels">
                            <Label for="modifiedresponse"><Icon path={mdiMessageText} size={0.9} className="form-label-icon" />Description</Label>
                            <Input type="textarea" name="modifiedresponse" className="form-control-sm" rows="7" id="modifiedresponse" value={this.state.modifiedresponse || ''} onChange={this.handleInputChange} />
                        </FormGroup>
                    </Col>                    
                </Row>
                
                <Row>
                    <Col md={12} className="submit_actions">
                    <button type="button" className="btn btn-dark close-button" onClick={this.props.exit}>Close</button>
                    
                    {
                        this.props.type != "aimenu"
                        ?
                        <button
                        className="btn attendeesearchbtn send_email"
                        onClick={() => { if (window.confirm('Do you accept this modified description?')) { this.handleAccept() }; }}
                        type="button"
                        text="Accept"
                        >Accept</button>  : ''                      
                    }

                    </Col>
                </Row>
            </div>            
        )
    }

    handleInvokeAI = async() => {
        this.setState({ loadingPopup: true });

        //var description = this.state.modifiedresponse == '' ? this.state.description : this.state.modifiedresponse; 
        var description = this.state.modifiedresponse
        var prompt = this.state.custom_prompt != '' && this.state.prompt_val == '' ? this.state.custom_prompt : this.state.prompt_val

        var ai_response = ''

        if(isOpenAi && prompt != '') {
            ai_response = await reWriteContent(openai,prompt,description,openai_model);
        }
        else {
            console.log('Invalid Ai');
        }

        this.setState({
            modifiedresponse: ai_response,
            loadingPopup: false
        })
    }
}

export default AiPromptPopUp;